"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpDetailedSectionTable = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var api_1 = require("../../../../api");
var Icon_1 = __importDefault(require("../../Icon/Icon"));
var use_mount_hook_1 = require("../../../../api/hooks/use-mount.hook");
var DpDetailedSectionTable_styled_1 = require("./DpDetailedSectionTable.styled");
var DpTableHeader_1 = require("./DpTableHeader");
var DpTableItem_1 = require("./DpTableItem");
var getTableItems = function (students, activeColumns, columnsToShow, totalHeaders, isVisible, showAssessment, classId, type, goToStudentReportHandler) {
    return students.map(function (item) { return ((0, jsx_runtime_1.jsx)(DpTableItem_1.DpTableItem
    // @ts-ignore
    , { data: item, activeColumns: activeColumns, columnsToShow: columnsToShow, totalHeaders: totalHeaders, isVisible: isVisible, showAssessment: showAssessment, classId: classId, type: type, goToStudentReportHandler: goToStudentReportHandler, isNotScrollable: totalHeaders <= columnsToShow }, item.id)); });
};
var DpDetailedSectionTable = function (_a) {
    /** ********************************STATE*************************************/
    var sectionData = _a.sectionData, multipleSections = _a.multipleSections, columnsToShow = _a.columnsToShow, headerColumns = _a.headerColumns, classId = _a.classId, type = _a.type, goToStudentReportHandler = _a.goToStudentReportHandler;
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var _b = (0, react_1.useState)([]), data = _b[0], setData = _b[1];
    var _c = (0, react_1.useState)([]), activeColumns = _c[0], setActiveColumns = _c[1];
    var _d = (0, react_1.useState)(), items = _d[0], setItems = _d[1];
    var _e = (0, react_1.useState)({
        direction: api_1.SortDirectionEnumerables.ascending,
        property: 'name',
    }), sortingCriteria = _e[0], setSortingCriteria = _e[1];
    var _f = (0, react_1.useState)(multipleSections), collapse = _f[0], setCollapse = _f[1];
    (0, react_1.useEffect)(function () {
        setData(sectionData);
    }, [sectionData]);
    var sortingCriteriaChanged = function (criteria) {
        setSortingCriteria(criteria);
        var copyArray = __spreadArray([], data, true);
        var overallRow = copyArray.shift();
        copyArray.sort((0, api_1.sortByCriteria)(criteria));
        copyArray.unshift(overallRow);
        setData(copyArray);
    };
    var navigateNext = function () {
        var newActive = activeColumns.map(function (column) { return column + 1; });
        setActiveColumns(newActive);
    };
    var navigateBack = function () {
        var newActive = activeColumns.map(function (column) { return column - 1; });
        setActiveColumns(newActive);
    };
    var toggleHandler = function () {
        setCollapse(!collapse);
    };
    (0, use_mount_hook_1.useMount)(function () {
        var actives = [];
        for (var i = 0; i < columnsToShow; i++) {
            actives.push(i);
        }
        setActiveColumns(actives);
    });
    (0, react_1.useMemo)(function () {
        setItems(getTableItems(data, activeColumns, columnsToShow, headerColumns.length, !collapse, !!sectionData[0].assessment, classId, type, goToStudentReportHandler));
    }, [
        data,
        activeColumns,
        headerColumns,
        columnsToShow,
        collapse,
        sectionData,
        classId,
        type,
        goToStudentReportHandler,
    ]);
    return ((0, jsx_runtime_1.jsx)(DpDetailedSectionTable_styled_1.StyledDetailedSectionTable, { isNotScrollable: headerColumns.length <= columnsToShow, children: (0, jsx_runtime_1.jsxs)("table", { className: "detailed-section-table", tabIndex: 0, children: [(0, jsx_runtime_1.jsx)(DpTableHeader_1.DpTableHeader, { headerColumns: headerColumns, activeColumns: activeColumns, columnsToShow: columnsToShow, navigateNextHandler: navigateNext, navigateBackHandler: navigateBack, sortingCriteriaChangeHandler: sortingCriteriaChanged, sortingCriteria: sortingCriteria, showAssessment: !!sectionData[0].assessment }), (0, jsx_runtime_1.jsxs)("tbody", { children: [items, multipleSections && ((0, jsx_runtime_1.jsx)("tr", { children: (0, jsx_runtime_1.jsx)("td", { className: "see-details", colSpan: 7, children: (0, jsx_runtime_1.jsxs)("button", { onClick: toggleHandler, children: [(0, jsx_runtime_1.jsx)("span", { children: collapse
                                                ? t('studentsDetails.table.seeDetails')
                                                : t('studentsDetails.table.closeDetails') }), (0, jsx_runtime_1.jsx)(Icon_1.default, { name: collapse ? 'inverted-triangle' : 'triangle' })] }) }) }))] })] }) }));
};
exports.DpDetailedSectionTable = DpDetailedSectionTable;
exports.default = exports.DpDetailedSectionTable;
